function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 60.1457,
  cy: 60.8537,
  rx: 35.3801,
  ry: 35.3801,
  fill: "#0BE1BB"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M70.0324 46.5077C69.4987 47.2076 69.6333 48.2077 70.3332 48.7415C74.1334 51.6397 76.4062 56.1299 76.4062 61C76.4062 68.939 70.4013 75.4754 62.6858 76.3151L64.123 74.877C64.7454 74.2546 64.7454 73.2454 64.123 72.623C63.5572 72.0572 62.6718 72.0058 62.0479 72.4687L61.8691 72.623L57.6191 76.873C57.0533 77.4389 57.0019 78.3243 57.4648 78.9482L57.6191 79.127L61.8691 83.377C62.4915 83.9993 63.5007 83.9993 64.123 83.377C64.6889 82.8111 64.7403 81.9257 64.2774 81.3018L64.123 81.123L62.5288 79.5318C72.0827 78.7543 79.5938 70.7543 79.5938 61C79.5938 55.1249 76.8487 49.7018 72.2662 46.2069C71.5663 45.6732 70.5662 45.8078 70.0324 46.5077ZM57.877 38.623C57.2546 39.2454 57.2546 40.2546 57.877 40.877L59.4691 42.4684C49.9162 43.2469 42.4062 51.2464 42.4062 61C42.4062 66.6195 44.9164 71.832 49.1655 75.3419C49.8441 75.9024 50.8486 75.8067 51.4092 75.1281C51.9698 74.4495 51.8741 73.4449 51.1955 72.8844C47.6719 69.9737 45.5938 65.6584 45.5938 61C45.5938 53.0618 51.5975 46.5258 59.3121 45.6852L57.877 47.123C57.2546 47.7454 57.2546 48.7546 57.877 49.377C58.4993 49.9994 59.5085 49.9994 60.1309 49.377L64.3809 45.127C65.0033 44.5046 65.0033 43.4954 64.3809 42.873L60.1309 38.623C59.5085 38.0007 58.4993 38.0007 57.877 38.623Z",
  fill: "white"
});

function SvgPendingStatusSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatusSmall);
export default __webpack_public_path__ + "static/media/pending_status_small.0fc3f777.svg";
export { ForwardRef as ReactComponent };